import React from "react";
import { withTranslation } from "react-i18next";
// import preval from "preval.macro";

// const buildDate = preval`module.exports = new Date().toISOString().split("T")[0]`;

const styles = {
    container: {
        fontSize: "smaller",
    },
};

const LastUpdated = () => {
    const version = process.env.REACT_APP_VERSION;
    return <span style={styles.container}>{version}</span>;
};

// const LastUpdated = ({ t }) => {
//     return (
//         <span style={styles.container}>
//             {t("Last updated at")} {buildDate}
//         </span>
//     );
// };

export default withTranslation()(LastUpdated);
